'use client'

import { useState } from 'react'
import { useParams } from 'next/navigation'
import { Button, cn, LeftArrow } from '@desoutter/uikit'
import { ProductCard } from '@/components/Cards/ProductCard/ProductCard'
import { getSpecs } from '@/utils/getSpecsFromItemSpecificationBlocs'

type ProductDetailsCarouselProps = {
	items: {
		model: string
		partnumber: string
		thumbnail: string
		SpecificationBlocks: {
			Imperial: { [key: string]: string }
			Metric: { [key: string]: string }
			Universal: { [key: string]: string }
		}
	}[]
	title: string
	trackingClassname?: string
}

export default function ProductDetailsCarousel({
	items,
	title,
	trackingClassname,
}: ProductDetailsCarouselProps) {
	const { lang } = useParams()
	const [offset, setOffset] = useState(0)

	function scroll(dir: 'prev' | 'next', name: string, length: number) {
		const width = 308
		if (dir === 'next')
			setOffset((prev) => {
				const next = prev - width
				if (-length * width < next) return next
				return prev
			})
		if (dir === 'prev')
			setOffset((prev) => {
				const next = prev + width
				if (prev * width < 0) return next
				return prev
			})
	}

	return (
		<div
			id={'spy_' + title.replaceAll(' & ', ' ').replaceAll(' ', '_')}
			className="relative z-0 overflow-hidden"
		>
			<div className={cn('container-auto', { hidden: !items?.length })}>
				<div className="flex items-baseline justify-between">
					<div className="h4 mb-8">{title}</div>
					<div className="hidden md:flex gap-4">
						<Button
							icon={LeftArrow}
							variant="outline"
							color="tertiary"
							title="backward"
							onClick={() => scroll('prev', 'items', items.length)}
						/>
						<Button
							variant="outline"
							color="tertiary"
							title="forward"
							onClick={() => scroll('next', 'items', items.length)}
						/>
					</div>
				</div>
				<div className="relative">
					<div
						className="relative flex w-screen ml-[-16px] mr-[32px] md:ml-[0px] md:mr-[8px] gap-3 md:gap-7 transition-all duration-500 ease-in-out max-md:overflow-auto max-md:touch-auto"
						style={{ left: offset }}
					>
						{items.map((product: any) => (
							<ProductCard
								model={product.model}
								imageUrl={
									!!product.thumbnail &&
									product.thumbnail +
										'/jcr:content/renditions/cq5dam.web.400.400.jpeg'
								}
								partnumber={product.partnumber}
								specs={
									product.specificationBlocks
										? getSpecs(product.specificationBlocks, lang as string)
										: []
								}
								key={product.partnumber}
								className="max-md:mx-4"
								trackingClassname={trackingClassname}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}
